import { render, staticRenderFns } from "./EducationalScheduleUsers.vue?vue&type=template&id=21d33124&"
import script from "./EducationalScheduleUsers.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports